const configuratorClass = document.getElementById("activeConfiguratorIcon").value;

const getActiveConfiguratorDepthIconClass = () => {
  switch (configuratorClass) {
    case "icon-point":
      return "icon-Arbetsdjup-pinne";
    case "icon-disc":
      return "icon-working_depth_medium_1";
    case "icon-roller":
      return "icon-roller";
    default:
      return '';
  }
};

const getActiveConfiguratorSizeIconClass = () => {
  switch (configuratorClass) {
    case "icon-point":
      return "icon-Bredd";
    case "icon-disc":
      return "icon-Tallriksdiameter";
    case "icon-roller":
      return "icon-roller";
    default:
      return '';
  }
};

export { getActiveConfiguratorDepthIconClass, getActiveConfiguratorSizeIconClass }